import React from 'react';
import debounce from 'debounce';
import PropTypes from 'prop-types';


import { Avatar, Button, Col, Collapse, Icon, InputNumber, List, message, Popconfirm, Row, Tag, Tooltip } from 'antd';

import CustomProductSelector from './custom-product-selector';

import {
  _deleteHoldingList,
  _deleteHoldingListProduct,
  _postSetCustomBulkDiscount,

  _postAddEmptyCustomProductToHoldingList,
  _postSelectCustomProduct,
  _postUpdateHoldingListSerialNumber,
  _postUpdateHoldingListQuantity,
  _postUpdateHoldingListPrices,
} from '../../../services';

const Panel = Collapse.Panel;

class HoldingListController extends React.Component{

	render(){

		const { holdingList } = this.state;


    // console.log(holdingList)

		return (
			<Collapse 
        activeKey={[
          this.props.selectedListId, 
          ...this.state.activeKeys
        ]} 
        onChange={this.handleOnToggleCollapse}>

        <Panel  
          header={(
            <Tooltip
              placement="right"
              title={holdingList.notes}>
              {holdingList.name}: {holdingList.products.length} products
            </Tooltip>
          )}
          key={holdingList._id} >

          

          <Row>
            <List
              itemLayout="horizontal"
              dataSource={holdingList.products}
              renderItem={(_item, productIndex) => (
                
                <List.Item 
                  actions={[
                    <a 
                      onClick={() => this.handleDeleteProduct(holdingList._id, productIndex)}>
                        <Icon type="close" />
                        {/* <span>{_item.product.title}</span> */}
                    </a>
                  ]}>

                  <Row type="flex" align="middle" justify="center" style={{width: '100%'}}>

                    <Col span={4}>

                      <InputNumber
                        style={{ width: '60px' }}
                        onChange={ newSerialNumber => this.handleChangeSerialNumber(holdingList._id, newSerialNumber, productIndex)}
                        value={_item.serialNumber}
                      />
                    
                    </Col>

                    <Col span={18}>

                      <List.Item.Meta
                        avatar={<Avatar src={_item.product.images[0].url} shape="square" size="large" />}
                        title={ this.renderItemName( _item, productIndex ) }
                        description={(
                        <Row>
                          {this.renderVariantName(_item.variants)}
                          {this.renderPrice(_item, productIndex, holdingList._id)}

                        </Row>
                        )}
                      />
                    </Col>

                    <Col span={2}>

                      <InputNumber
                        style={{ width: '60px' }}
                        onChange={ quantity => this.handleOnChangeQuantity({
                          holdingListId: holdingList._id,
                          productIndex,
                          quantity
                        })}
                        value={_item.quantity}
                        min={1}
                      />

                    </Col>

                  </Row>

                </List.Item>
              )}
            />

          </Row>

          <Row type="flex" justify="center">
            <Col>
              <Button onClick={ this.handleOnAddNewLine }>
                Add Custom Product
              </Button>
            </Col>
          </Row>

          <Row type="flex" justify="center">
            <Col span={12} align="middle">
            <Popconfirm 
                title="Are you sure?" 
                onConfirm={() => this.handleReorderHoldingList(holdingList._id)} 
                okText="Yes" 
                cancelText="No">
                
                <Button>Reorder</Button>
              
              </Popconfirm>
            </Col>
            <Col span={12} align="middle">
              <Popconfirm 
                title="Are you sure?" 
                onConfirm={() => this.handleDeleteHoldingList(holdingList._id)} 
                okText="Yes" 
                cancelText="No">
                
                <Button disabled={ typeof this.props.handleOnDeleteHoldingList !== "function" } type="danger">Delete</Button>

              </Popconfirm>
            </Col>
          </Row>
        </Panel>

      </Collapse>
		);
	}

	renderFreeDeliveryTag = ( productOrder ) => {

    if( productOrder.product.movFreeDelivery ){
      
      let totalPrice = this.getTotalPrice(productOrder);

      if( (totalPrice * productOrder.quantity) > productOrder.product.movFreeDelivery ){
        return (
          <Tag 
            style={{ marginLeft: 8 }} 
            color="green">Free Delivery</Tag>
        );
      } else {
        return (
          <Tag 
            style={{ marginLeft: 8 }}
            color="orange">Free Delivery > {productOrder.product.movFreeDelivery}
          </Tag>
        )
      }

    }

    return null;
  }

	renderItemName = ( product, productIndex ) => {

    if( product.product.customProduct ){

      return (
        <div>

          <CustomProductSelector 
            updateProduct={this.updateProduct}

            holdingListId={ this.state.holdingList._id }
            productIndex={ productIndex }

            price={product.product.price.original}
            onSelectCustomProductTitle={ ( customProduct ) => this.handleonSelectCustomProductTitle({ customProduct, productIndex }) }
            title={product.product.title}
            _id={ product.product.customProductId}
            />

          {this.renderFreeDeliveryTag(product)}
        </div>
      )
    }

    return (
      <div>
        {product.product.title}
        {this.renderFreeDeliveryTag(product)}
      </div>
    )
    
  }


	renderPrice = ( productOrder, productIndex, holdingListId ) => {
    
    let bulkDiscount = [];

    let totalPrice = this.getTotalPrice( productOrder );

    const BulkDiscountButton = ({ discount, productDiscount }) => (
      <Button 
        type={ productDiscount === discount && productOrder.quantity > 1? "primary": "" }
        onClick={() => this.handleOnSetBulkDiscount({
          discount, 
          productIndex, 
          holdingListId
        })} 
        size="small">- {discount}%</Button>
    );

    let productBulkDiscount = productOrder.product.bulkDiscount.sort(
      ( a, b ) => {
        return a.quantity > b.quantity
      }
    );

    if( productBulkDiscount.length > 0 && productOrder.quantity >= productBulkDiscount[0].quantity ){

      let discountTier = productBulkDiscount.reduce(
        ( acc, cur ) => {

          if ( productOrder.quantity >= cur.quantity ) {
            return cur;
          }

          return acc;
        }, {}
      )

      bulkDiscount = (
        <Col>
          Bulk Discount {discountTier.quoteAndForgetCustomBulkDiscount}% Applied
        </Col>
			);
			
    } else {
      bulkDiscount = [
        <Col>
          <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={0} />
        </Col>,
        <Col>
          <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={3} />
        </Col>,
        <Col>
          <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={5} />
        </Col>,
        <Col>
          <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={7} />
        </Col>,
        <Col>
          <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={10} />
        </Col>
      ]
    }

    return (
      <Row type="flex" align="middle" gutter={8}>

        <Col>
          ${totalPrice}
          {/* {productOrder.product.price.po} */}
        </Col>
        {/* {variantKeys.map(
          key => (
            <Col key={key}>
              + {productOrder.variants[key].price.po}
            </Col>
          )
        )} */}
        {bulkDiscount}
      </Row>  
    )
	}
	
	renderVariantName = ( variants ) => {

    if( !variants ){
      return null;
    }

    const variantKeys = Object.keys(variants);

    return (
      <Row style={{ fontSize: 12, color: "#595959"}}>
        {variantKeys.map(
          key => (
            <div key={key} style={{ paddingRight: 8 }}>
              {key}: {variants[key].name}
            </div>
          )
        )}
      </Row>
    );
	}
	
	constructor( props ){
		super(props);

    this._dbnceUpdateHoldingListQuantity = debounce( this._dbnceUpdateHoldingListQuantity, 300 );
    // this._dbnceUpdateCustomProductTitle = debounce( this._dbnceUpdateCustomProductTitle, 600 );

		this.state = {
      holdingList: props.holdingList,
      activeKeys: []
		}
  }

  componentDidMount(){
    //update enterprise prices
    _postUpdateHoldingListPrices({
      enterpriseId: this.props.enterpriseId,
      holdingListId: this.props.holdingList._id
    })
    .then( res => {
      this.setState({
        holdingList: res.data.holdingList
      })
    })
  }

  static getDerivedStateFromProps( nextProps, prevState ){

    if(nextProps.holdingList._id !== prevState.holdingList._id ){
      return { holdingList: nextProps.holdingList };
    }
   
    return null;
  }
  
  // _dbnceUpdateCustomProductTitle = ({ holdingListId, productIndex, productTitle }) => {

  //   _postUpdateCustomProductTitle({
  //     holdingListId, 
  //     productIndex, 
  //     productTitle
  //   })

  // }

  _dbnceUpdateHoldingListQuantity = ({ holdingListId, productIndex, quantity }) => {

    _postUpdateHoldingListQuantity({ holdingListId, productIndex, quantity, enterpriseId: this.props.enterpriseId })
      .then( res => {
        message.destroy();
        message.success(`${res.data.product.product.title} -> ${quantity}`);

        this.setState({
          holdingList: {
            ...this.state.holdingList,
            products: this.state.holdingList.products.map( ( _p, index ) => {

              if( index === productIndex ){
                return res.data.product;
              }

              return _p;
            })
          }
        });

        // this.props.setHoldingListProduct({
        //   product: res.data.product,
        //   productIndex,
        //   holdingListId
        // });

      });

  }


	getTotalPrice = ( productOrder ) => {
    return productOrder.totalAmount.price;
  }

	handleChangeSerialNumber = (holdingListId, newSerialNumber, productIndex) => {

    const { holdingList } = this.state;

    let { products } = holdingList;

    products = products.map( ( _p, i ) => {
      
      if( i === productIndex ){
        _p.serialNumber = newSerialNumber;
      }

      return _p;
    });

    this.setState({
      holdingList: {
        ...this.state.holdingList,
        products
      }
    });

  }

	handleDeleteHoldingList = ( holdingListId ) => {

    if( this.props.handleOnDeleteHoldingList && typeof this.props.handleOnDeleteHoldingList === "function" ){
      // let _id = this.props.createdLists[index]._id;
      _deleteHoldingList( holdingListId )
        .then(res => {
  
          this.props.handleOnDeleteHoldingList( holdingListId );

        }).catch(err => {
          // alert( JSON.stringify(err.response) );
        });
    }
	}
	
	handleDeleteProduct = (holdingListId, productIndex) => {
 
    const { holdingList } = this.state;

    let product = holdingList.products[ productIndex ];

    let loadingMsg = message.loading(`Deleting ${product.product.title}`, 0);

    setTimeout( () => {
      _deleteHoldingListProduct({
        holdingListId,
        productIndex
      })
        .then( res => {
  
          loadingMsg();

          this.setState({
            holdingList: {
              ...holdingList,
              products: holdingList.products.filter( (p,i) => i !== productIndex )
            }
          });

        })
    }, 300 );

  }

  handleOnAddNewLine = () => {

    const { holdingList } = this.state;

    let loader = message.loading("Adding Custom Product", 0);

    // let customProduct = {
    //   customProduct: true,
    //   product: {
    //     title: "",
    //     price: {
    //       original: 0,
    //       sale: 0
    //     }
    //   },
    //   quantity: 1,
    //   variants: {},
    //   offer: false
    // }

    // this.setState({ holdingList: {
    //   ...this.state.holdingList,
    //   products: [
    //   ...this.state.holdingList.products,
    //   res.data.product
    //   ]
    // }});


    _postAddEmptyCustomProductToHoldingList({
      holdingListId: holdingList._id 
    })
      .then( res => {

        setTimeout(() => {          
          
          loader();

          this.setState({ holdingList: {
            ...this.state.holdingList,
            products: [
              ...this.state.holdingList.products,
              res.data.product
            ]
          }}, () => {
            this.props.updateHoldingListProduct(holdingList._id, this.state.holdingList.products);
          });


        }, 300);

      })

  }

  // handleOnChangeCustomProductTitle = ({
  //   holdingListId,
  //   productIndex,
  //   productTitle
  // }) => {

  //   // this.setState({
  //   //   holdingList: {
  //   //     ...this.state.holdingList,

  //   //     products: this.state.holdingList.products.map(
  //   //       (product, index) => {

  //   //         if( index === productIndex ){
  //   //           return {
  //   //             ...product,
  //   //             product: {
  //   //               ...product.product,
  //   //               title: productTitle
  //   //             }
  //   //           }
  //   //         }

  //   //         return product;
  //   //       }
  //   //     )
  //   //   }
  //   // })
  //   this._dbnceUpdateCustomProductTitle({
  //     holdingListId,
  //     productIndex,
  //     productTitle  
  //   })

  // }

	handleOnChangeQuantity = ({
    holdingListId,
    productIndex,
    quantity
  }) => {

    let actualValue;

    if ( quantity === null) {
      actualValue = 1;
    } else {
      actualValue = quantity;
    }
    
    // _postUpdateHoldingListQuantity

    let { products } = this.state.holdingList;

    products = products.map( (_p, i) => {

      if( productIndex === i ){
        _p.quantity = quantity;
      }

      return _p;
    })
    
    this.setState({
      holdingList: {
        ...this.state.holdingList,
        products
      }
    });

    // this.props.updateHoldingListProductQuantity({
    //   quantity: actualValue,
    //   holdingListId,
    //   productIndex
    // })
    
    this._dbnceUpdateHoldingListQuantity({
      quantity: actualValue,
      holdingListId,
      productIndex
    });
    
  }

  handleonSelectCustomProductTitle = ({ customProduct, productIndex }) => {

    const { holdingList } = this.state;

    return _postSelectCustomProduct({ 
			holdingListId: holdingList._id, 
			productIndex,
			customProductId: customProduct._id 
    })
      .then( res => {

        this.setState({
          holdingList: {
            ...this.state.holdingList,
            products: this.state.holdingList.products.map(
              (product, index) => {
                
                if( index === productIndex ){
                  return res.data.product
                }

                return product;
              }
            )
          }
        })

        return res.data.product;

      })

  }

  updateProduct = ({ productIndex, product }) => {

    this.setState({
      holdingList: {
        ...this.state.holdingList,
        products: this.state.holdingList.products.map(
          (_product, index) => {
            
            if( index === productIndex ){
              return product
            }

            return _product;
          }
        )
      }
    })

  }

  handleOnSetBulkDiscount = ({
    discount, 
    productIndex, 
    holdingListId
  }) => {

    _postSetCustomBulkDiscount({
      discount, 
      productIndex, 
      holdingListId
    })
      .then( res => {

        this.setState({
          holdingList: {
            ...this.state.holdingList,
            products: this.state.holdingList.products.map( ( _p, i ) => {
    
              if( i === productIndex ){
                return res.data.product;
              }
    
              return _p;
    
            })
          }
        });

      })
      .catch( e => {
        console.log( e.response.data )
        message.error( e.response.data.msg )
      })
    
    

  }

  handleOnToggleCollapse = () => {

    const { holdingList } = this.state;

    let activeKeys;

    if( this.state.activeKeys.length === 0 ){
      activeKeys = [ holdingList._id ];
    } else {
      activeKeys = [];
    }

    this.setState({
      activeKeys
    });

  }

	handleReorderHoldingList = (holdingListId) => {

    let holdingListProductsSerialNumber = this.state.holdingList.products.reduce(
      ( acc, cur ) => {

        acc.push( cur.serialNumber );

        return acc;
      }, []
    );

    _postUpdateHoldingListSerialNumber({
      holdingListId,
      holdingListProductsSerialNumber
    })
      .then( res => {

        const { holdingList } = res.data

        this.setState({
          holdingList
        });

        this.props.updateHoldingListProduct(holdingListId, holdingList.products)

        message.success(`${holdingList.name} reindexed!`)
        
      })

  }

}

HoldingListController.propTypes = {

  // required
  selectedListId: PropTypes.string.isRequired,
  holdingList: PropTypes.any.isRequired,

  // optional
  handleOnDeleteHoldingList: PropTypes.func

};


export default HoldingListController;


// WEBPACK FOOTER //
// ./src/components/quotation/add-quotation-modal/holding-list-controller.js